// Dog Breed Cards card game data with rankings
export const DOG_BREED_CARDS = [
  {
    "id": 32,
    "name": "French Bulldog",
    "rank": 1,
    "image": "/images/dogBreed/dogBreed_1.jpg"
  },
  {
    "id": 2,
    "name": "Labrador Retriever",
    "rank": 2,
    "image": "/images/dogBreed/dogBreed_2.jpg"
  },
  {
    "id": 3,
    "name": "Golden Retriever",
    "rank": 3,
    "image": "/images/dogBreed/dogBreed_3.jpg"
  },
  {
    "id": 4,
    "name": "German Shepherd",
    "rank": 4,
    "image": "/images/dogBreed/dogBreed_4.jpg"
  },
  {
    "id": 5,
    "name": "Poodle",
    "rank": 5,
    "image": "/images/dogBreed/dogBreed_5.jpg"
  },
  {
    "id": 6,
    "name": "Dachshund",
    "rank": 6,
    "image": "/images/dogBreed/dogBreed_6.jpg"
  },
  {
    "id": 7,
    "name": "Beagle",
    "rank": 7,
    "image": "/images/dogBreed/dogBreed_7.jpg"
  },
  {
    "id": 8,
    "name": "Rottweiler",
    "rank": 8,
    "image": "/images/dogBreed/dogBreed_8.jpg"
  },
  {
    "id": 9,
    "name": "Bulldog",
    "rank": 9,
    "image": "/images/dogBreed/dogBreed_9.jpg"
  },
  {
    "id": 10,
    "name": "German Shorthaired Pointer",
    "rank": 10,
    "image": "/images/dogBreed/dogBreed_10.jpg"
  },
  {
    "id": 11,
    "name": "Yorkshire Terrier",
    "rank": 11,
    "image": "/images/dogBreed/dogBreed_11.jpg"
  },
  {
    "id": 12,
    "name": "Australian Shepherd",
    "rank": 12,
    "image": "/images/dogBreed/dogBreed_12.jpg"
  },
  {
    "id": 13,
    "name": "Cavalier King Charles Spaniel",
    "rank": 13,
    "image": "/images/dogBreed/dogBreed_13.jpg"
  },
  {
    "id": 14,
    "name": "Cane Corso",
    "rank": 14,
    "image": "/images/dogBreed/dogBreed_14.jpg"
  },
  {
    "id": 15,
    "name": "Pembroke Welsh Corgi",
    "rank": 15,
    "image": "/images/dogBreed/dogBreed_15.jpg"
  },
  {
    "id": 16,
    "name": "Doberman Pinscher",
    "rank": 16,
    "image": "/images/dogBreed/dogBreed_16.jpg"
  },
  {
    "id": 17,
    "name": "Boxer",
    "rank": 17,
    "image": "/images/dogBreed/dogBreed_17.jpg"
  },
  {
    "id": 18,
    "name": "Miniature Schnauzer",
    "rank": 18,
    "image": "/images/dogBreed/dogBreed_18.jpg"
  },
  {
    "id": 19,
    "name": "Bernese Mountain Dog",
    "rank": 19,
    "image": "/images/dogBreed/dogBreed_19.jpg"
  },
  {
    "id": 20,
    "name": "Shih Tzu",
    "rank": 20,
    "image": "/images/dogBreed/dogBreed_20.jpg"
  },
  {
    "id": 21,
    "name": "Great Dane",
    "rank": 21,
    "image": "/images/dogBreed/dogBreed_21.jpg"
  },
  {
    "id": 22,
    "name": "Pomeranian",
    "rank": 22,
    "image": "/images/dogBreed/dogBreed_22.jpg"
  },
  {
    "id": 23,
    "name": "Boston Terrier",
    "rank": 23,
    "image": "/images/dogBreed/dogBreed_23.jpg"
  },
  {
    "id": 24,
    "name": "Miniature American Shepherd",
    "rank": 24,
    "image": "/images/dogBreed/dogBreed_24.jpg"
  },
  {
    "id": 25,
    "name": "Havanese",
    "rank": 25,
    "image": "/images/dogBreed/dogBreed_25.jpg"
  },
  {
    "id": 26,
    "name": "Siberian Husky",
    "rank": 26,
    "image": "/images/dogBreed/dogBreed_26.jpg"
  },
  {
    "id": 27,
    "name": "Chihuahua",
    "rank": 27,
    "image": "/images/dogBreed/dogBreed_27.jpg"
  },
  {
    "id": 28,
    "name": "English Springer Spaniel",
    "rank": 28,
    "image": "/images/dogBreed/dogBreed_28.jpg"
  },
  {
    "id": 29,
    "name": "Shetland Sheepdog",
    "rank": 29,
    "image": "/images/dogBreed/dogBreed_29.jpg"
  },
  {
    "id": 30,
    "name": "Border Collie",
    "rank": 30,
    "image": "/images/dogBreed/dogBreed_30.jpg"
  }
];
